import React from "react";

export default function DocumentSkeleton({
  isDarkMode = false,
}: {
  isDarkMode?: boolean;
}) {
  const base = isDarkMode
    ? "bg-gray-800 text-gray-300"
    : "bg-white text-gray-700";
  const card = isDarkMode
    ? "bg-gray-800 border-gray-700"
    : "bg-white border-gray-200";
  const shimmer = isDarkMode ? "bg-gray-700" : "bg-gray-200";

  return (
    <div className={`p-6 ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <div className="mx-auto space-y-6">
        <div className={`rounded-lg border ${card} p-4`}>
          <div className="flex items-center gap-3">
            <div className={`h-8 w-64 rounded ${shimmer} `} />
            <div className={`h-8 w-40 rounded ${shimmer} `} />
            <div className={`h-8 w-28 rounded ${shimmer} `} />
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          {[...Array(3)].map((_, i) => (
            <div key={i} className={`rounded-lg border ${card} p-4 space-y-3`}>
              <div className={`h-4 w-24 rounded ${shimmer} `} />
              <div className={`h-8 w-32 rounded ${shimmer} `} />
              <div className={`h-3 w-full rounded ${shimmer} `} />
            </div>
          ))}
        </div>

        <div className={`rounded-lg border ${card}`}>
          <div
            className={`p-4 border-b ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}
          >
            <div className={`h-6 w-40 rounded ${shimmer} `} />
          </div>
          <div className="divide-y divide-gray-200 dark:divide-gray-700">
            {[...Array(8)].map((_, i) => (
              <div key={i} className="grid items-center grid-cols-12 gap-4 p-4">
                <div className={`col-span-5 h-4 rounded ${shimmer} `} />
                <div className={`col-span-2 h-4 rounded ${shimmer} `} />
                <div className={`col-span-2 h-4 rounded ${shimmer} `} />
                <div className={`col-span-3 h-8 rounded ${shimmer} `} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
